import React from 'react'
import TrainingBanner from './TrainingBanner'
import TrainingOperation from './TrainingOperation'
import TrainingService from './TrainingService'
import TrainingResult from './TrainingResult'
import TraingMastery from './TraingMastery'
import HealthcareFacility from '../../Industries/Healthcare/HealthcareFacility'
import HealthcareFaq from '../../Industries/Healthcare/HealthcareFaq'
import TrainingServiceWork from './TrainingServiceWork'

export default function Training() {
    const Banner = {
        image: "/assets/images/training-banner.webp",
        heading: "Operational Confidence Starts On The Floor",
        description: "We train your team directly on the equipment they will use every day, covering operation, maintenance, safety, and troubleshooting so your facility performs at full potential from day one.",
        buttonText: "Learn More",
        link: "/contact",
    }
    const operationData = {
        subtitle: "Professional Training",
        headingLine1: "Knowledge That Keeps ",
        headingLine2: "Your Facility Moving",
        description: "Supershine training is designed for the people who run your facility every day. From correct equipment operation and routine maintenance to safety compliance and fault recognition, our programmes build the kind of practical capability that reduces downtime, extends machine life, and keeps output quality consistent regardless of who is on shift.",
        buttonText: "Schedule Your Training",
        buttonLink: "/contact"
    }
    const trainingData = {
        title: "What Makes Supershine Training Different?",
        description: "Most equipment training stops at the basics. Supershine programmes go further, covering real operating conditions, common fault scenarios, and facility-specific workflows so your team builds genuine competence rather than just surface-level familiarity with the machines.",
        image: "/assets/images/training-service-img.webp",
        buttonText: "Request Training",
        link: "/contact",
    }
    const resultData = {
        heading: "What Your Team Gains From Day One",
        description: "Practical skills developed on your actual equipment, applied immediately on the floor and built to last across every shift and every operator.",
        items: [
            {
                image: "/assets/images/result-img1.webp",
                title: "Fewer Breakdowns, Longer Machine Life",
                text: "Operators who understand their equipment catch early warning signs, follow correct procedures, and avoid the small daily misuse that quietly shortens machine lifespan."
            },
            {
                image: "/assets/images/result-img2.webp",
                title: "Faster Output, Fewer Errors",
                text: "Trained teams move through wash cycles, loading sequences, and handover processes with confidence, cutting the hesitation and mistakes that slow production down."
            },
            {
                image: "/assets/images/result-img3.webp",
                title: "A Team That Does Not Need Constant Supervision",
                text: "When operators are genuinely trained, supervisors spend less time firefighting and more time managing output. Independence on the floor is a direct result of proper training."
            },
            {
                image: "/assets/images/result-img4.webp",
                title: "Lower Running Costs Over Time",
                text: "Correct chemical dosing, accurate temperature settings, and efficient cycle management add up. Well-trained teams consistently use less water, less energy, and fewer consumables per load.",
                extraClass: "last-training-col"
            }
        ]
    }
    const ServiceFaq = {
        heading: "How The Training <br> Process Works",
        image: "/assets/images/service-work-img.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                question: "Initial Assessment",
                answer: "We review your facility, equipment, team size, and current skill gaps to understand exactly what your operators need before a single training session is designed.",
            },
            {
                question: " Training Programme Design",
                answer: "A structured programme is built around your specific machines, daily workflows, and operational priorities so every session covers what actually matters on your floor.",
            },
            {
                question: "On-Site Or Online Delivery",
                answer: "Training is delivered directly at your facility or remotely depending on your preference, ensuring minimal disruption to your production schedule during the programme.",
            },
            {
                question: "Reference Materials And Follow-Up",
                answer: "Operators receive practical reference guides they can use on the job, backed by post-training support from our team for questions that come up after the sessions end.",
            },
        ],

    };
    const masteryData = {
        headingLine1: "Less Guesswork.",
        headingLine2: " More Uptime.",
        description: "When your operators are trained on the exact equipment they run every day, the difference shows immediately in cycle times, machine care, and the number of avoidable stoppages each week.",
        buttonText: "Learn more",
        buttonLink: "/contact",
        bgImage: "/assets/images/mastery-bg.webp",
    }

    const facilityData = {
        title: "Which Teams Benefit Most?",
        items: [
            {
                icon: "/assets/images/traing-facility-icon1.webp",
                heading: "Hotels And Hospitality",
                description: "Operators handling daily linen turnover who need to maintain output quality and meet tight housekeeping deadlines across every shift."
            },
            {
                icon: "/assets/images/traing-facility-icon2.webp",
                heading: "Industrial Laundry Units",
                description: "High-volume processing teams where correct machine handling, cycle discipline, and fault recognition directly impact daily throughput."
            },
            {
                icon: "/assets/images/traing-facility-icon3.webp",
                heading: "Healthcare And Institutions",
                description: "Staff working in infection-sensitive environments where wash temperature compliance, safe linen handling, and contamination control are non-negotiable."
            },

            {
                icon: "/assets/images/traing-facility-icon4.webp",
                heading: " Self-Service Laundries",
                description: "Self-service laundry staff who can quickly fix equipment issues, assist customers confidently, and keep machines running smoothly without outside help."
            },
            {
                icon: "/assets/images/traing-facility-icon5.webp",
                heading: "Industrial Facilities",
                description: "Production and maintenance teams operating laundry equipment as part of a larger facility where downtime has a direct cost to the wider operation."
            },


            {
                icon: "/assets/images/traing-facility-icon6.webp",
                heading: "Multi-Site Operations",
                description: "Managers overseeing laundry across multiple locations who need consistent operator standards, uniform processes, and reliable output at every site."
            }
        ]
    };
    const expertData = {
        title: "Experience In The Room Makes The Difference",
        description: "Our trainers bring years of hands-on laundry industry knowledge into every session. That background means they anticipate the questions your operators actually have, address the problems that come up in real facilities, and deliver training that sticks long after the session ends.",
        image: "/assets/images/expert-image.webp",
        buttonText: "Connect With Specialists",
        link: "/contact",
    }

    const faqData = {
        title: "FAQs",
        description:
            "Straight answers to help you get the right training in place for your team.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "What Does Supershine Training Cover?",
                answer: "Each programme covers equipment operation, routine maintenance, wash cycle management, safety procedures, and fault recognition, structured around the specific machines your team works with every day.",
            },
            {
                question: " Who Should Attend The Training?",
                answer: "Anyone who operates, supervises, or maintains laundry equipment in your facility. This includes machine operators, shift supervisors, maintenance staff, and anyone responsible for daily production output.",
            },
            {
                question: "Is The Training Practical Or Classroom-Based?",
                answer: " Primarily hands-on. Sessions are built around real equipment and real operating conditions so your team develops skills they can apply immediately, not just knowledge they have to translate later.",
            },

            {
                question: "Can The Programme Be Built Around Our Facility?",
                answer: "Yes. Every Supershine training programme is structured around your specific equipment, team size, shift patterns, and operational priorities so the content is relevant from the first session.",
            },

            {
                question: " How Long Does A Training Programme Take?",
                answer: "Duration depends on team size, equipment complexity, and the scope of topics covered. Most programmes are completed within one to three days, with flexible scheduling to minimise production disruption.",
            },

            {
                question: " Do You Offer On-Site Training?",
                answer: "Yes. We deliver training directly at your facility so your team learns on the equipment they use in the environment they work in every day, which produces faster and more lasting results.",
            },
        ],
    };

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/training",
                name: "Training"
            }
        ]
    }

    return (
        <>
            <TrainingBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
            <TrainingOperation data={operationData} />
            <TrainingService data={trainingData} />
            <TrainingResult data={resultData} />
            <TrainingServiceWork data={ServiceFaq} />
            <TraingMastery data={masteryData} />
            <HealthcareFacility data={facilityData} />
            <TrainingService data={expertData} />
            <HealthcareFaq data={faqData} />
        </>
    )
}
